import {toSnakeCase} from "services/string";

/**
 * Get a copy of the given object with all keys changed to snake case
 *
 * @param object
 */
export function snakeKeys(object: object): object {
    const keys = Object
      .keys(object)
      .map(key => toSnakeCase(key))

    return Object.fromEntries(
      Object
        .values(object)
        .map((value, index) => [keys[index], value])
    )
}

/**
 * Get a copy of the given object with empty (null, undefined or '') values removed
 *
 * @param object
 */
export function withoutEmpty(object: object): object {
    return Object.fromEntries(
      Object
        .entries(object)
        .filter(([,value]) => value !== null && value !== undefined && value !== '')
    )
}